<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-22 10:58:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-05-27 15:17:13
 * @FilePath: 
 * @Description: 支付方式组件
-->
<template>
  <div>
    <van-radio-group v-model="radio">
      <van-cell title="微信支付">
        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
        <template #icon>
          <g-img2 src="wx_icon.png" class="l-img" size="40"></g-img2>
        </template>
        <template #right-icon>
          <!-- <g-img
            :src="require('@/assets/images/checked3.png')"
            class="l-img"
            :size="40"
          ></g-img> -->
          <van-radio name="wechat">
            <template #icon="props">
              <img
                style="width: 20px"
                :src="props.checked ? activeIcon : inactiveIcon"
              />
            </template>
          </van-radio>
        </template>
      </van-cell>

      <!-- <van-cell v-if="!fromPage">
        <template>
          <div>
            <span>会员卡支付</span>
            <span class="c-sub-txt">/暂无</span>
          </div>
        </template>
        <template #icon>
          <g-img2 class="l-img" src="VIP" size="40"></g-img2>
        </template>
        <template #extra>
          <div class="c-tc" @click="bindRealCard">绑定实体卡</div>

        </template>
      </van-cell> -->
      <van-collapse v-model="activeNames" v-if="fromPage !== 'noCardPay'">
        <van-collapse-item name="1">
          <template #title>
            <div>
              <g-img2 class="l-img" src="VIP" size="40"></g-img2>
              <span>会员卡支付 {{ memberArr.length > 0 ? "" : "/暂无" }}</span>
            </div>
          </template>
          <template #value>
            <div class="c-tc m-r-20">
              <span @click.stop="bindRealCard">绑定实体卡</span>
            </div>
          </template>
          <member-list
            :list="memberArr"
            @click="handleSelectCard"
          ></member-list>
        </van-collapse-item>
      </van-collapse>
    </van-radio-group>
    <nonSecretPay
      :show.sync="memberPayShow"
      :list="nowSelectMemberInfo"
      :recAmount="origMoney"
      @paySuccess="memberPaySuccess"
    ></nonSecretPay>
  </div>
</template>

<script>
import { handleSessionStorage } from "@/utils";
import nonSecretPay from "@/newViews/goods/comps/nonSecretPay";
import memberList from "@/newViews/goods/comps/memberList.vue";
export default {
  props: {
    origMoney: {
      type: Number,
      default: 0,
    },
    fromPage: {
      //用于判断是否展示会员支付
      type: String,
      default: "",
    },
  },
  components: {
    nonSecretPay,
    memberList,
  },
  data() {
    return {
      activeNames: ["1"],
      memberArr: [],
      radio: "wechat",
      memberPayShow: false,
      nowSelectMemberInfo: {},
      activeIcon: require("@/assets/radio/radio-active.png"),
      inactiveIcon: require("@/assets/radio/radio-unactive.png"),
    };
  },
  created() {
    this.getMemberList();
  },
  methods: {
    getMemberList() {
      const params = {
        IsBindWx: true,
        VpnId: this.$store.state.vpnId,
      };
      $http("wechath5/zh-cn/v1/member/list", params, "get").then((res) => {
        this.memberArr = res;
      });
    },
    handleSelectCard(data) {
      if (data.LeaveMoney + data.DonationMoney < this.origMoney) {
        this.$toast("余额不足，请选择其他方式");
      }
      this.nowSelectMemberInfo = data;
    },
    bindRealCard() {
      this.$router.push("/member/bindRealCard");
    },
    memberPaySuccess() {
      this.$toast("会员卡支付成功");
      // location.href = this.globalReturnUrl;
    },
    handlePayByCard(moneyData, orderId) {
      let params = {
        OrderId: orderId,
        MemberPayments: [
          {
            MemberId: this.nowSelectMemberInfo.Id, // 会员账户id
            ConsumeMoney: moneyData, // 会员支付金额
            CardTypeId: this.nowSelectMemberInfo.CardTypeId, // 会员卡种id
            RowVersion: this.nowSelectMemberInfo.RowVersion, // 数据版本标识
            CardCode: this.nowSelectMemberInfo.CardCode,
            CardTypeName: this.nowSelectMemberInfo.CardTypeName,
          },
        ],
      };
      $http("wechath5/zh-cn/v1/member/pay", params, "post").then((res) => {
        console.log("44444333<<<  res  >>>44444");
        console.log(res);
        this.$router.push({
          path: `/consumecode-detail/${orderId}`,
        });
        // location.href = location.href.split('#')[0] + '#/consumecode-detail/' + res;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.l-img {
  margin-right: 20px;
  display: inline-block;
}
</style>
